import {
    all,
    call,
    put,
    SagaIterator,
    select,
    takeEvery,
    takeEveryCompletedRequest,
    takeEveryErrorRequest,
    takeEveryFatalErrorRequest
} from 'acscp/sagas/core/sagaEffects';
import {
    disablePushNotifications, enablePushNotifications, getPushNotificationId
} from 'acscp/sagas/helpers/pushNotification';
import { UpdateSubscribedPushNotificationChannelsRequest } from 'acscp/api/requests/updateSubscribedPushNotificationChannelsRequest';
import { AppResumed, FetchRequest, NetworkConnected, UpdatePushNotificationChannelSubscriptions } from 'acscp/actions';
import { isNotificationChannelSubscriptionPendingSelector } from 'acscp/store/selectors/isNotificationChannelSubscriptionPendingSelector';
import { userIsFullyLoggedInOrFullyLoggedOut } from 'acscp/store/selectors/userIsFullyLoggedInOrFullyLoggedOut';
import { waitFor } from './core/waitFor';

export function* updateSubscribedPushNotificationChannelsSaga(): SagaIterator {
    yield all([
        takeEvery(UpdatePushNotificationChannelSubscriptions, updatePushNotificationSubscriptions),

        takeEvery(AppResumed, updatePushNotificationSubscriptionsIfPending),
        takeEvery(NetworkConnected, updatePushNotificationSubscriptionsIfPending),

        takeEveryCompletedRequest(UpdateSubscribedPushNotificationChannelsRequest, enablePushNotifications),
        // try to prevent the device from receiving notifications that it shouldn't:
        takeEveryErrorRequest(UpdateSubscribedPushNotificationChannelsRequest, disablePushNotifications),
        takeEveryFatalErrorRequest(UpdateSubscribedPushNotificationChannelsRequest, disablePushNotifications),
    ]);
}

function* updatePushNotificationSubscriptionsIfPending(): SagaIterator {
    const isUpdatePending = yield select(isNotificationChannelSubscriptionPendingSelector);
    if (isUpdatePending) {
        yield call(updatePushNotificationSubscriptions);
    }
}

function* updatePushNotificationSubscriptions(): SagaIterator {
    const pushNotificationId = (yield call(getPushNotificationId)) as unknown as string | null;
    if (pushNotificationId) {
        yield call(waitFor, userIsFullyLoggedInOrFullyLoggedOut);
        yield put(new FetchRequest(new UpdateSubscribedPushNotificationChannelsRequest(pushNotificationId)));
    }
}
